var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H15.5517V7.44828H16.5517V0H0V16.5517H7.44824V15.5517H1V1Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.44828V10.7586H23.1724V8.27586H20.6897V7.44828H24Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44828 14.069H8.27586V17.3793H7.44828V14.069Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27586 20.6897H7.44828V24H10.7586V23.1724H8.27586V20.6897Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.6897H23.1724V23.1724H20.6897V24H24V20.6897Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.069H23.1724V17.3793H24V14.069Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44828 7.44828V10.7586H8.27586V8.27586H10.7586V7.44828H7.44828Z",
    fill: "current"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.069 23.1724H17.3793V24H14.069V23.1724Z",
    fill: "current"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3793 7.44828H14.069V8.27586H17.3793V7.44828Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveBack);
export default __webpack_public_path__ + "static/media/MoveBack.db95ad7254690baa12e7003f4a719bab.svg";
export { ForwardRef as ReactComponent };